import { PageWrapper } from 'layout/PublicLayout/Wrappers';
import Details from './Details';
import View from './View';
import { Suspense } from 'react';
import { useTranslation } from 'react-i18next';

const LoadingFallback = () => {
    const { t } = useTranslation();

    return <div>{t('Loading')}</div>;
};

export const PublicAthletesView = () => {
    return (
        <PageWrapper>
            <Suspense fallback={<LoadingFallback />}>
                <View />
            </Suspense>
        </PageWrapper>
    );
};

export const PublicAthleteDetailsView = () => {
    return (
        <PageWrapper>
            <Suspense fallback={<LoadingFallback />}>
                <Details />
            </Suspense>
        </PageWrapper>
    );
};
